
// Navbar Component 
function Navbar(){
    return (
        <div className="navbar">
            <div className="logo">
                <a href="/">
                    <img src="./images/logo.png" alt=""/>
                </a>
            </div>
        </div>
    )
}

export default Navbar;
